import { Box } from "@material-ui/core";
import * as React from "react";
import { EventStatus } from "../../../../../models/enums/eventStatus.enum";

interface EventItemStatusTextProps {
  status: EventStatus;
  slots: number;
  slots_taken: number;
  eventWorkload: number;
}

const EventItemStatusText: React.FunctionComponent<EventItemStatusTextProps> = ({
  status,
  slots,
  slots_taken,
  eventWorkload,
}) => {
  const freeSlots = slots - slots_taken;
  return (
    <Box style={{ height: "1.0625rem" }}>
      {eventWorkload >= 80 && eventWorkload < 100 && status !== EventStatus.Full && (
        <span>
          {"(" + freeSlots + (freeSlots === 1 ? " freier Platz" : " freie Plätze") + ")"}
        </span>
      )}
    </Box> //to match the height of the text above
  );
};

export default EventItemStatusText;

// TODO no translation yet
